import { render } from "./IconsSection.vue?vue&type=template&id=0b8ee60a"
import script from "./IconsSection.vue?vue&type=script&lang=js"
export * from "./IconsSection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__